import { useContext, useEffect, useState } from "react";
import { configuracoesApi } from "../../../hooks/configuracoesApi";
import { ConfiguracoesContext } from "../../../contexts/Configuracoes/ConfiguracoesContext";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import { Input } from "../../Input";
import { Toggle } from "../../Toggle/Toggle";
import { ContainerNumeracaoPedidos } from "./styles";

export const NumeracaoPedidos: React.FC = () => {
  const { theme } = useTheme();
  const { configuracoes, setConfiguracoes } = useContext(ConfiguracoesContext);

  const [ultimoNumero, setUltimoNumero] = useState(0);

  useEffect(() => {
    configuracoesApi()
      .buscar_numeracao_pedidos()
      .then((numeracao) => setUltimoNumero(Number(numeracao?.ultimo_numero) || 0))
      .catch((error) => console.log(error));
  }, []);

  const numeroSequencial = configuracoes.numero_sequencial;
  const ativo = !!numeroSequencial?.ativo;
  const textoNumero =
    typeof numeroSequencial?.numero_inicial === "string"
      ? numeroSequencial.numero_inicial
      : "";
  const numeroInicial = Number(textoNumero) || 0;
  const inicialJaPassou = !!numeroInicial && numeroInicial <= ultimoNumero;
  const formatar = (numero: number) => String(numero).padStart(4, "0");

  // só valida o que foi editado agora, pra um valor antigo não travar o Salvar da tela toda
  const [editado, setEditado] = useState(false);
  const numeroInvalido = editado && inicialJaPassou;
  const mensagemInvalido = `O último pedido foi o #${formatar(ultimoNumero)}. Informe um número maior.`;

  const atualizar = (valores: Partial<typeof numeroSequencial>) => {
    setConfiguracoes({
      ...configuracoes,
      numero_sequencial: {
        ativo,
        numero_inicial: textoNumero,
        ...valores,
      },
    });
  };

  return (
    <ContainerNumeracaoPedidos theme={theme}>
      <div className="titulo-secao fonteSubtitulo">Numeração dos pedidos</div>
      <div className="texto fonteTexto">
        Defina se deseja apresentar os pedidos em ordem sequencial definida pela sua empresa.
      </div>
      <div className="toggleContainer fonteTexto">
        <Toggle
          value={ativo}
          onChange={(novoValor) => {
            setEditado(true);
            // ao reativar, sugere o próximo número real
            atualizar(
              novoValor && ultimoNumero > 0 && numeroInicial <= ultimoNumero
                ? { ativo: true, numero_inicial: formatar(ultimoNumero + 1) }
                : { ativo: novoValor }
            );
          }}
        ></Toggle>
        <span>Pedidos com números sequenciais</span>
      </div>

      {ativo && (
        <div className="bloco-input">
          <div className="label-numero fonteTexto">
            Defina o número inicial dos pedidos
          </div>
          <div className="campo-numero">
            <Input
              type="text"
              placeholder="#0001"
              value={textoNumero}
              maxLength={4}
              onChange={(newValue) => {
                setEditado(true);
                atualizar({
                  numero_inicial: newValue.replace(/\D/g, "").slice(0, 4),
                });
              }}
              isValid={{
                isValidFunction: () => !numeroInvalido,
                dependencies: [numeroInvalido],
              }}
              invalidText={mensagemInvalido}
            />
          </div>
          {numeroInvalido && (
            <div className="aviso fonteTexto">{mensagemInvalido}</div>
          )}
          {!editado && inicialJaPassou && (
            <div className="aviso fonteTexto">
              A numeração já passou desse número: o próximo pedido será o #
              {formatar(ultimoNumero + 1)}.
            </div>
          )}
        </div>
      )}
    </ContainerNumeracaoPedidos>
  );
};
